<template>
  <header class="header-global sticky-top">
    <base-nav class="navbar-main navbar-transparent" type="darker" effect expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <h1 class="h3 text-ferdas">Ferdas Hostel Scheme</h1>
        <!-- <img src="img/brand/white.png" alt="logo"> -->
      </router-link>

      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-8 collapse-brand">
          <a href="/">
            <span class="text-ferdas h5">Ferdas Hostel Scheme</span>
            <!-- <img src="img/brand/blue.png" /> -->
          </a>
        </div>
        <div class="col-4 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>
      <!-- links /landing /profile /register  -->
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item">
          <router-link to="/registered-hostels" class="nav-link">Browse Hostels</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/" class="nav-link">Hostel Owners</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/" class="nav-link">Support Center</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/signup" class="btn btn-outline-info mb-2 mb-sm-0">Sign up</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/signin" class="btn btn-outline-success mb-2 mb-sm-0">Sign in</router-link>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
</style>
